module.exports = __webpack_public_path__ + "static/media/catalyst-question-bg@2x.2b19da16.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/catalyst-question-bg@2x.png
// module id = 1127
// module chunks = 0